import { render, staticRenderFns } from "./RefIdDelete.vue?vue&type=template&id=6a60dbe7"
import script from "./RefIdDelete.vue?vue&type=script&lang=js"
export * from "./RefIdDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports